<template>
<div class="MRegister m-login">
    <ResetRegister ref="resetRegister" @resetregister="_doRegister">
        <template v-slot:tip>
            <div class="outerBox">
                <div class="box">
                    <van-checkbox v-model="checked">我同意<span class="tc-blue"><a href="https://m.capwhale.com/index/userTerms.html">《服务协议》</a></span>和<span class="tc-blue"><a href="https://m.capwhale.com/index/privacy.html">《隐私政策》</a></span>
                    </van-checkbox>
                </div>
                <div class="tip"></div>
            </div>
        </template>
        <template v-slot:btn>
            <van-button type="info" size="large" @click="doRegister" :disabled="!checked">注册</van-button>
        </template>
        <template v-slot:resetRegister>
            <router-link :to="{name: 'MResetPwd'}">忘记密码</router-link>
        </template>
    </ResetRegister>
</div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import ResetRegister from 'views/mobile/login/components/resetRegister'
import {userRegister} from 'api/api'
export default {
    name: 'MRegister',
    data() {
        return {
            checked: false
        }
    },
    methods: {
        doRegister() {
            this.$refs.resetRegister.ver()
        },
        _doRegister(obj) {
            this.setLoading(true)
            userRegister({
                data: obj,
                success: () => {
                    this.setLoading(false)
                    this.$toast.success('注册成功')
                    this.$router.push({name: 'MLogin'})
                },
                error: data => {
                    this.setLoading(false)
                    this.$toast.fail(data.msg || data.mesg)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([])
    },
    components: {
        ResetRegister
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~views/mobile/login/login";
.MRegister {
}
</style>